package com.exura.features.demosets.domain.usecase

import com.exura.features.demosets.domain.DemoSetsConstants
import com.exura.features.demosets.domain.model.ImportDemoSetResponse
import com.exura.features.demosets.domain.model.ImportPublicDemoSetRequest
import dev.gitlive.firebase.functions.FirebaseFunctions

class ImportPublicDemoSetUseCase(
    private val functions: FirebaseFunctions,
) {

    suspend operator fun invoke(
        demoSetId: String,
    ): Result<List<String>> = runCatching {
        val importCallable = functions.httpsCallable(DemoSetsConstants.Functions.IMPORT_DEMO_SET)

        val request = ImportPublicDemoSetRequest(
            demoSetId = demoSetId,
        )

        val result = importCallable(request)
        val response = result.data<ImportDemoSetResponse>()

        if (response.success) {
            response.importedPlanIds.toList()
        } else {
            throw Exception(response.message ?: "Failed to import demo set")
        }
    }
}
